import React, { useEffect, useRef, useState } from "react";
import {
  AiOutlineClose,
  AiOutlineZoomIn,
  AiOutlineZoomOut,
} from "react-icons/ai";

import { buildSrcSet } from "../utils/imageUrl";

const MIN_SCALE = 1;
const MAX_SCALE = 3;
const STEP = 0.5;

const ImageModal = ({ image, alt = "Product Image", onClose }) => {
  const [scale, setScale] = useState(MIN_SCALE);
  const wrapRef = useRef(null);

  // Nayi image khule to zoom reset
  useEffect(() => {
    setScale(MIN_SCALE);
  }, [image]);

  useEffect(() => {
    const handleKeyDown = (e) => {
      if (e.key === "Escape") {
        onClose();
      }
    };
    window.addEventListener("keydown", handleKeyDown);
    return () => {
      window.removeEventListener("keydown", handleKeyDown);
    };
  }, [onClose]);

  // stopPropagation zaroori hai, warna click overlay tak jaakar popup close kar deta hai
  const zoomIn = (e) => {
    e.stopPropagation();
    setScale((s) => Math.min(MAX_SCALE, s + STEP));
  };

  const zoomOut = (e) => {
    e.stopPropagation();
    setScale((s) => Math.max(MIN_SCALE, s - STEP));
  };

  const handleClose = (e) => {
    e.stopPropagation();
    setScale(MIN_SCALE);
    onClose();
  };

  // Zoom ke baad scroll ko center par le aao
  const centerScroll = () => {
    const el = wrapRef.current;
    if (!el) return;
    el.scrollLeft = (el.scrollWidth - el.clientWidth) / 2;
    el.scrollTop = (el.scrollHeight - el.clientHeight) / 2;
  };

  const isZoomed = scale > MIN_SCALE;

  const zoomBtnClass =
    "text-white bg-white/20 rounded-full p-2 hover:opacity-75 transition disabled:opacity-30 disabled:cursor-not-allowed";

  return (
    <div
      className="fixed inset-0 z-50 flex items-center justify-center bg-black/80 p-4"
      onClick={onClose}
    >
      <button
        onClick={handleClose}
        aria-label="Close image"
        className="absolute top-4 right-4 z-10 text-white bg-white/20 rounded-full p-2 hover:opacity-75 transition"
      >
        <AiOutlineClose size={22} />
      </button>

      {/* Zoom controls */}
      <div
        className="absolute top-4 left-4 z-10 flex flex-col items-center gap-2"
        onClick={(e) => e.stopPropagation()}
      >
        <button
          type="button"
          onClick={zoomIn}
          disabled={scale >= MAX_SCALE}
          aria-label="Zoom in"
          className={zoomBtnClass}
        >
          <AiOutlineZoomIn size={22} />
        </button>
        <span className="text-white text-xs select-none">{scale}x</span>
        <button
          type="button"
          onClick={zoomOut}
          disabled={scale <= MIN_SCALE}
          aria-label="Zoom out"
          className={zoomBtnClass}
        >
          <AiOutlineZoomOut size={22} />
        </button>
      </div>

      {/* Image container: zoom hone par scroll */}
      <div
        ref={wrapRef}
        onClick={(e) => e.stopPropagation()}
        className="max-w-[90vw] max-h-[90vh] rounded-md"
        style={{ overflow: isZoomed ? "auto" : "hidden" }}
      >
        <img
          src={image}
          srcSet={buildSrcSet(image) || undefined}
          sizes="(min-width: 768px) 80vw, 92vw"
          alt={alt}
          draggable={false}
          onTransitionEnd={centerScroll}
          className="block max-w-[90vw] max-h-[90vh] w-auto h-auto object-contain"
          style={{
            transform: `scale(${scale})`,
            transformOrigin: "top left",
            transition: "transform 0.2s ease",
          }}
        />
      </div>
    </div>
  );
};

export default ImageModal;
